import { Spinner as HeroSpinner } from '@heroui/react';
import { FC } from 'react';

import { SpinnerWrapper } from './styles';

export type SpinnerProps = {
  global?: boolean;
  showLabel?: boolean;
  containerHeight?: string;
  variant?: 'default' | 'simple' | 'gradient' | 'wave' | 'dots' | 'spinner';
  size?: 'sm' | 'md' | 'lg';
}

export const Spinner: FC<SpinnerProps> = ({
  global = false,
  showLabel,
  containerHeight, variant = 'default', size = 'md',
}) => (
  <SpinnerWrapper
    data-testid="spinner"
    global={global}
    containerHeight={containerHeight}
  >
    <HeroSpinner
      label={showLabel ? 'loading...' : ''}
      variant={variant}
      size={size}
      color="primary"
    />
  </SpinnerWrapper>
);
